<template>
  <v-app>
    <v-container fluid>
      <v-layout row wrap>

        <!--    Diálogo Persistente para mostrar Errores   -->
        <v-dialog v-model="dialog_errores"
                  persistent
                  width="400"
        >
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
<!--                    <h3 class="text-xs-center">{{errores_guard}}</h3>-->
                    <div class="text-xs-center" v-html="errores_guard" />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
<!--                    <v-btn-->
<!--                            v-if="band_tolerance"-->
<!--                            color="success"-->
<!--                            x-small-->
<!--                            :loading="loading"-->
<!--                            @click="create_acceso_tolerance()"-->
<!--                    >{{$t('force_access')}}-->
<!--                    </v-btn>-->
                    <v-btn
                            v-if="band_gafete"
                            color="primary"
                            x-small
                            :loading="loading_gafete"
                            @click="download_gafete"
                    >{{$t('print_name_tag')}}
                    </v-btn>
                    <!-- <v-btn
                            v-if="survey"
                            color="primary"
                            x-small
                            @click="dialogShowSurvey = true"
                    >{{$t('answer')}}
                    </v-btn> -->
                    <v-btn
                            color="primary"
                            @click="dialog_errores = false, errores_guard = '', activar_camara = true, band_gafete = false, bandAccessNoCode = false, bandPreregisterNoCode = false, band_tolerance = false,
                            dataAccessNoCode = {
                                    'id': 0,
                                    'id_vigilante': 0,
                                    'id_caseta': 0,
                                    'id_empresa':0 ,
                                    'id_empleado': 0,
                                    'id_area': 0,
                                    'f_acceso': '',
                                    'f_salida': '',
                                    'url_foto': '',
                                    'nombre': '',
                                    'telefono': '',
                                    'empresa': '----------',
                                    'notas': '',
                                    'estado': 0,
                                    'authorized': false,
                                    'pase_salida': false,
                                    'count_authorized': 2,
                                    'count_pase_salida': 2
                                  }"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Columna izquierda: Cámara -->
        <v-flex xs12 md3>
          <v-card>
            <v-card-title primary-title>
              <h3>Escanear Código QR</h3>
            </v-card-title>

            <v-card-text>
              <qrcode-stream
                @decode="onDecode"
                @init="onInit"
              ></qrcode-stream>

              <div v-if="cameraError" class="red--text mt-2">
                {{ cameraError }}
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

        <!-- Columna derecha: Datos del usuario -->
        <v-flex xs12 md9>
          <v-card>
            <v-card-title primary-title>
              <h3>Datos del Usuario</h3>
            </v-card-title>

            <v-card-text>
              <v-alert v-if="loading" type="info">
                Cargando datos...
              </v-alert>

              <v-alert v-show="error" type="error">
                {{ error }}
              </v-alert>
              <div v-if="user">

                <v-layout row wrap>
                    <v-flex xs12 sm6>
                        <v-img
                            :src="user.idFront"
                        ></v-img>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-autocomplete
                            autofocus
                            v-model="id_empleado"
                            prepend-icon="person"
                            name="id_empleado"
                            :item-text="example"
                            item-value="id"
                            :label="$t('Empleado')"
                            :filter="customFilter"
                            :error-messages="errores.id_empleado"
                            :items="empleados"
                            :no-data-text="$t('no_resultados')"
                            clearable
                        ></v-autocomplete>

                        <v-autocomplete
                            v-model="id_area"
                            prepend-icon="location_city"
                            name="id_area"
                            item-text="nombre"
                            item-value="id"
                            :label="$t('Area')"
                            :filter="customFilterArea"
                            :error-messages="errores.id_area"
                            :items="areas"
                            :no-data-text="$t('no_resultados')"
                            clearable
                        >
                        </v-autocomplete>

                        <v-text-field
                            v-model="nombre"
                            prepend-icon="person_outline"
                            name="nombre"
                            :label="$t('nombre')"
                            :error-messages="errores.nombre"
                        >
                        </v-text-field>

                        <!-- <v-text-field
                            v-model="empresa"
                            prepend-icon="business"
                            name="empresa"
                            :label="$t('Empresa')"
                            :error-messages="errores.empresa"
                        >
                        </v-text-field> -->

                        <v-text-field
                            v-model="notas"
                            prepend-icon="notes"
                            name="notas"
                            :label="$t('Notas')"
                            :error-messages="errores.notas"
                        >
                        </v-text-field>
                    </v-flex>
                </v-layout>

              </div>

                <div align="center">
                <v-flex
                    xs12 class="text-xs-center"
                    v-if="!dataAccessNoCode.authorized && bandAccessNoCode === true"
                >
                    <h3>{{$t('attemps')}} : {{dataAccessNoCode.count_authorized}}/2</h3>
                </v-flex>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                    <div v-on="on">
                        <v-btn
                            v-if="dataAccessNoCode.count_authorized === 2 && bandPreregisterNoCode === false"
                            :disabled="user === null"
                            large
                            color="primary"
                            @click="createPreregisterNoCodeWaitingRoom()"
                            :loading="loading"
                        >
                            <v-icon>living</v-icon>
                            {{$t('send_waiting_room')}}
                        </v-btn>
                    </div>
                    </template>
                    <span>{{user === null ? $t('msg_must_capture_photo') : $t('send_waiting_room')}}</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                    <div v-on="on">
                        <v-btn
                            v-if="dataAccessNoCode.count_authorized === 2"
                            :disabled="user === null"
                            large
                            color="primary"
                            @click="createPreregisterNoCode()"
                            :loading="loading"
                        >{{$t('send_and_notify_host_access')}}
                        </v-btn>
                    </div>
                    </template>
                    <span>{{user === null ? $t('msg_must_capture_photo') : $t('send_and_notify_host_access')}}</span>
                </v-tooltip>
                <v-btn
                    v-if="dataAccessNoCode.authorized"
                    large
                    color="success"
                    :loading="loading"
                    @click="create_access_no_code(dataAccessNoCode.id)"
                >{{$t('acceso')}}
                </v-btn>
                <v-btn
                    v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized === 0"
                    large
                    color="yellow"
                    :loading="loading"
                    @click="create_access_no_code(dataAccessNoCode.id)"
                >{{$t('acceso')}}
                </v-btn>
                <v-btn
                    v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0 && countDownAuthorizedAccessNoCode === 0 && bandAccessNoCode"
                    color="primary"
                    large
                    :loading="loading"
                    @click="notificar_anfitrion_acceso_sin_codigo(dataAccessNoCode.id)">
                    Notificar al anfitrión <br> autorizar acceso
                </v-btn>
                <v-btn
                    v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0 && countDownAuthorizedAccessNoCode > 0"
                    large
                    color="primary"
                >
                    Disponible en : {{countDownAuthorizedAccessNoCode}}
                </v-btn>
                <v-btn
                    v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized != 0 && bandAccessNoCode"
                    large
                    :loading="loadingCountInAccessNoCode"
                    color="primary"
                    @click="getRecordAccessNoCodeById(dataAccessNoCode.id)"
                >
                    <v-icon>refresh</v-icon>
                </v-btn>
                </div>
              <div v-if="!user && !loading" class="text-xs-center">
                Escanee un QR para obtener información.
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader"
import jsPDF from 'jspdf'
import store from '@/store'

export default {
  components: {
    QrcodeStream
  },
  data() {
    return {
      user: null,
      data: null,
      error: null,
      loading: false,
      cameraError: null,

      id_empleado: '',
      id_area: '',
      areas: [],
      empleados: [],
      errores: [],
      nombre: '',
      telefono: '',
      empresa: '----------',
      notas: '',

      countDownAuthorizedAccessNoCode: 0,
      dataAccessNoCode: {
        'id': 0,
        'id_vigilante': 0,
        'id_caseta': 0,
        'id_empresa':0 ,
        'id_empleado': 0,
        'id_area': 0,
        'f_acceso': '',
        'f_salida': '',
        'url_foto': '',
        'nombre': '',
        'telefono': '',
        'empresa': '----------',
        'notas': '',
        'estado': 0,
        'authorized': false,
        'pase_salida': false,
        'count_authorized': 2,
        'count_pase_salida': 2
      },
      dialog_errores: false,
      loading_gafete: false,
      errores_guard: '',
      head_color: '',
      band_gafete: false,
      bandAccessNoCode: false,
      bandPreregisterNoCode: false,
      loadingCountInAccessNoCode: false,
      file: null,
      info_invitation: [],
    };
  },
  created: function(){
    this.getUsersCompany()
    this.getAreas()
  },
  methods: {
    async onDecode(qrContent) {
      const toDataUrl = (url, callback) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = () => {
          const reader = new FileReader();
          reader.onloadend = () => {
            callback(reader.result);
          };
          reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
      };
      console.log('Scaner = ', qrContent)
      if (qrContent.length > 0) {
        this.loading = true
        this.error = null
        this.user = null
        // Define the parameters as an object
        const params = {
            search: qrContent
        }
        // Create a query string from the params object
        const queryString = new URLSearchParams(params).toString()

        try {
            // Llamada al endpoint con el contenido del QR
            const res = await fetch("https://escuela-service.intrare.app/users/integration/filter?" + queryString)
            
            if (!res.ok) throw new Error("No se encontraron datos del usuario.")
            
            this.data = await res.json()
            // console.log('User = ', this.user)
            if (this.data.length > 0) {
                this.user = this.data[0]
                this.nombre = this.data[0].full_name
                console.log('Tiene datos =', this.data[0])
                // toDataUrl(this.data[0].idFront, (INE) => {
                //   this.file = INE
                // });
                this.getFileFromUrl(this.data[0].idFront, 'my_image.jpg', "image/png")
                .then(file => {
                    console.log(file)
                    this.file = file
                    // You can now use the 'file' object (e.g., in a FormData object for upload)
                })
                .catch(error => {
                    console.error('Error converting URL to file:', error);
                });
                // (async () => {
                //   this.file = await this.imageUrlToFile(this.data[0].idFront, 'my_image')
                // })();
            } else {
                console.log('No tiene datos.')
                this.error = 'Codigo QR, No valido!.'
                this.cleanFields()
            }
        } catch (err) {
            this.error = err.message
        } finally {
            this.loading = false
        }
      }
    },
    async imageUrlToFile(imageUrl, filename = 'image') {
      // Fetch the image
      const response = await fetch(imageUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch image: ${response.statusText}`);
      }

      // Convert to Blob
      const blob = await response.blob();

      // Extract MIME type (e.g., image/jpeg, image/png)
      const mimeType = blob.type || 'image/jpeg';

      // Extract file extension from MIME type
      const ext = mimeType.split('/')[1];

      // Create and return File object
      return new File([blob], `${filename}.${ext}`, { type: mimeType });
    },
    cleanFields () {
      this.user = null
      this.data = null
      this.id_empleado = ''
      this.id_area = ''
      this.errores = [],
      this.nombre = ''
      this.telefono = ''
      this.empresa = '----------'
      this.notas = ''
      this.$store.commit('snackbar_activate_false')
      this.$store.commit('snackbar_change_color', 'success')
    },
    onInit(promise) {
      promise.catch(error => {
        if (error.name === "NotAllowedError") {
          this.cameraError = "Permiso de cámara denegado."
        } else if (error.name === "NotFoundError") {
          this.cameraError = "No se encontró una cámara disponible."
        } else {
          this.cameraError = "Error al inicializar la cámara."
        }
      });
    },
    getUsersCompany (){
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/empresas/usuarios/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      };
      axios(config)
          .then(response => {
            this.empleados = response.data
            console.log(this.empleados)
          })
          .catch(error => {
            console.log(error)
          })

    },
    customFilterArea (item, queryText) {
      const textOne = item.nombre.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    customFilter (item, queryText) {
      const textOne = item.first_name.toLowerCase()
      const textTwo = item.last_name.toLowerCase()
      const textThree = item.email.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
          || textTwo.indexOf(searchText) > -1
          || textThree.indexOf(searchText) > -1

    },
    example: item => item.first_name + ' ' + item.last_name +' - ' + item.email,
    getAreas () {
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/empresas/areas/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      };
      axios(config)
          .then(response => {
            this.areas = response.data

            console.log(this.id_empresa)
          })
          .catch(error => {
            console.log(error)
          })

    },
    getRecordAccessNoCodeById(id) {
      this.loadingCountInAccessNoCode = true
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/bitacora/' + id,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
        },
      };
      axios(config)
          .then(ok => {
            this.loadingCountInAccessNoCode = false
            this.dataAccessNoCode = ok.data[0]
            console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
            console.log(this.dataAccessNoCode)
            console.log('Id = ', this.dataAccessNoCode.id)
          })
          .catch(error => {
            this.loadingCountInAccessNoCode = false
            console.log(error)
          })
    },
    countDownTimerAccessNoCode(id) {
      if(this.countDownAuthorizedAccessNoCode > 0) {
          setTimeout(() => {
              this.countDownAuthorizedAccessNoCode -= 1
              this.countDownTimerAccessNoCode(id)
          }, 1000)
      } else {
        const config2 = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/bitacora/' + id,
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
          },
        };
        axios(config2)
            .then(ok => {
              this.dataAccessNoCode = ok.data[0]
              console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
              console.log(this.dataAccessNoCode)
              console.log('Id = ', this.dataAccessNoCode.id)
            })
            .catch(error => {
              console.log(error)
            })
      }
    },
    notifyAuthorizedAccessNoCode() {
        this.loading = true
        console.log('Avisar al Anfitrión que autorize el acceso sin código dela persona = ', this.dataAccessNoCode.id)
        const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/notifyAuthorizedAccessNoCode/' + this.dataAccessNoCode.id + '/',
            headers: {
                'Content-Type': 'application/json',
            }
        };
        axios(config)
            .then(response => {
                this.loading = false
                this.countDownAuthorizedAccessNoCode = 30
                this.countDownTimerAccessNoCode()
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                setTimeout(this.clear, 3000)
            })
            .catch(error => {
                this.loading = false
                console.log(error)
            })
    },
    createPreregisterNoCode () {
      console.log('Datos de Antes del servidor: ')
      console.log(this.dataAccessNoCode)
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      var fileImageFront = null
      const newID = this.$uuid.v4()

      bodyFormData.set('id_empleado', this.id_empleado)
      bodyFormData.set('id_area', this.id_area)
      bodyFormData.set('id_caseta', localStorage.getItem('id_caseta'))
      bodyFormData.set('nombre', this.nombre)
      bodyFormData.set('telefono', '0000000000')
      bodyFormData.set('empresa', this.empresa)
      bodyFormData.set('notas', this.notas)
      bodyFormData.set('count_authorized', '1')
      if (this.user.idFront !== '' && this.user.idFront.length > 6) {
        fileImageFront = this.file
      }
      bodyFormData.append('url_foto', fileImageFront)
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/create_and_notify_grant_access_no_code/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'authorization': 'Token ' + store.getters.getToken,
          'Accept-Language': this.language,
        },
        data: bodyFormData
      };
      axios(config)
          .then(ok => {
            this.dataAccessNoCode = ok.data
            console.log('Datos devueltos por Servidor ala Crear un acceso sin codigo')
            console.log(this.dataAccessNoCode)
            console.log('Id = ', this.dataAccessNoCode.id)
            this.loading = false
            this.countDownAuthorizedAccessNoCode = 30
            this.countDownTimerAccessNoCode(this.dataAccessNoCode.id)
            this.bandAccessNoCode = true
            // this.$store.commit('snackbar_activate_true')
            // this.$store.commit('snackbar_change_color', 'success')
            // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_without'))
            // setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            if(error.response && error.response.status == 400
                && typeof error.response.data == "object"
                && error.response.data)
              this.errores = error.response.data
            else
            if(error.response.status == 404)
            {
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_color', 'error')
              this.$store.commit('snackbar_change_message', 'Token Inválido')
              setTimeout(this.clear, 3000)
            }
          })
          .finally(() => (this.loading = false))

    },
    createPreregisterNoCodeWaitingRoom () {
      console.log('Datos de Antes del servidor: ')
      console.log(this.dataAccessNoCode)
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      var fileImageFront = null
      const newID = this.$uuid.v4()

      bodyFormData.set('id_empleado', this.id_empleado)
      bodyFormData.set('id_area', this.id_area)
      bodyFormData.set('id_caseta', localStorage.getItem('id_caseta'))
      bodyFormData.set('nombre', this.nombre)
      bodyFormData.set('telefono', '0000000000')
      bodyFormData.set('empresa', this.empresa)
      bodyFormData.set('notas', this.notas)
      bodyFormData.set('count_authorized', '2')
      if (this.user.idFront !== '' && this.user.idFront.length > 6) {
        fileImageFront = this.file
      }
      bodyFormData.append('url_foto', fileImageFront)
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/create/waiting_room_access_no_code/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'authorization': 'Token ' + store.getters.getToken,
          'Accept-Language': this.language,
        },
        data: bodyFormData
      };
      axios(config)
          .then(ok => {
            this.dataAccessNoCode = ok.data
            console.log('Datos devueltos por Servidor ala Crear un acceso sin codigo')
            console.log(this.dataAccessNoCode)
            console.log('Id = ', this.dataAccessNoCode.id)
            this.loading = false
            this.bandPreregisterNoCode = true
            this.bandAccessNoCode = true
            this.cleanFields()
            this.errores_guard = 'Enviado a la Sala de Espera Correctamente'
            this.head_color = 'green display-1 text--primary'
            this.band_gafete = true
            this.dialog_errores = true
          })
          .catch(error => {
            this.loading = false
            if(error.response && error.response.status == 400
                && typeof error.response.data == "object"
                && error.response.data)
              this.errores = error.response.data
            else
            if(error.response.status == 404)
            {
              this.$store.commit('snackbar_activate_true')
              this.$store.commit('snackbar_change_color', 'error')
              this.$store.commit('snackbar_change_message', 'Token Inválido')
              setTimeout(this.clear, 3000)
            }
          })
          .finally(() => (this.loading = false))
    },
    create_access_no_code (id) {
        this.loading = true
        const config = {
            method: 'patch',
            url: 'https://empresa-service.intrare.app/update_access_no_code/' + id + '/',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            },
            data:{
              id_guardhouse_checkin: localStorage.getItem('id_caseta')
            }
        }
        axios(config)
            .then(response => {
                this.loading = false
                this.bandPreregisterNoCode = false
                this.errores_guard =this.$t('mensaje_alta_acceso_in')
                this.head_color = 'green display-1 text--primary'
                this.band_gafete = true
                this.dialog_errores = true
                this.cleanFields()
            })
            .catch(error => {
                this.loading = false
                console.log(error.response.data)
                this.head_color = 'red display-1 text--primary'
                this.errores_guard = error.response.data.error
                this.dialog_errores = true
            })
    },
    getCurrentDateSlash () {
      var today = new Date()
      var aux = ''
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      aux = dd + '-' + mm + '-' + yyyy
      return aux
    },
    getCurrentTime () {
      var today = new Date()
      var aux = ''
      var hh = today.getHours()
      var mm = today.getMinutes()

      if (hh < 10) {
        hh = '0' + hh
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      aux = hh + ':' + mm
      return aux
    },
    xOffset: function(pdf, text){
      return ((pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2) / 72.0)
    },
    download_gafete: function(){
      console.log('Bandera Acceso sin Codigo = ', this.bandAccessNoCode)
      this.loading_gafete = true
      console.log('Datos de la Invitación: ')
      console.log(this.info_invitation)
      // console.log(this.info_invitation)
      const toDataUrl = (url, callback) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = () => {
          const reader = new FileReader();
          reader.onloadend = () => {
            callback(reader.result);
          };
          reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
      };
      var pdf = new jsPDF('l', 'in', [288, 144])
      // Black square with rounded corners
      pdf.setDrawColor(0)
      pdf.setFontSize(9)
      pdf.text(this.$t('fecha_hora_acceso'),
          2.3,
          0.4)
      pdf.setLineWidth(0.02)
      pdf.line(2.3, 0.42, 3.7, 0.42)
      pdf.setFontStyle("normal")
      pdf.text(this.getCurrentDateSlash() + ' ' + this.getCurrentTime(), 2.7, 0.6)
      pdf.setFontSize(14)
      // pdf.setFillColor(255, 255, 255)
      // pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
      // pdf.setFontStyle("bold")
      // pdf.text(this.info_invitation.empresa,
      //     this.xOffset(pdf, this.info_invitation.empresa),
      //     130)
      pdf.line(this.xOffset(pdf, this.$t('Visitante').toUpperCase()), 0.92, 2.6, 0.92)
      pdf.setFontStyle("bold")
      pdf.text(this.$t('Visitante').toUpperCase(),
          this.xOffset(pdf, this.$t('Visitante').toUpperCase()),
          0.9)
      pdf.setFontSize(16)
      pdf.setFontStyle("normal")
      pdf.text(this.bandAccessNoCode === true ? this.dataAccessNoCode.nombre : this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName,
          this.xOffset(pdf, this.bandAccessNoCode === true ? this.dataAccessNoCode.nombre : this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName),
          1.2)
      pdf.line(this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()), 1.47, 2.6, 1.47)
      pdf.setFontSize(14)
      pdf.setFontStyle("bold")
      pdf.text(this.$t('Anfitrion').toUpperCase(),
          this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()),
          1.45)
      pdf.setFontSize(16)
      pdf.setFontStyle("normal")
      pdf.text(this.bandAccessNoCode === true ? this.dataAccessNoCode.host : this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName,
          this.xOffset(pdf, this.bandAccessNoCode === true ? this.dataAccessNoCode.host : this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName),
          1.70)
      // pdf.setFontStyle("normal")
      // pdf.text(this.$t('Area'),
      //     this.xOffset(pdf, this.$t('Area')),
      //     205)
      // pdf.setTextColor(this.info_invitation.areaColor)
      // pdf.setFontStyle("bold")
      // pdf.text(this.info_invitation.areaName.toUpperCase(),
      //     this.xOffset(pdf, this.info_invitation.areaName.toUpperCase()),
      //     220)
      pdf.setTextColor('#000000')
      // pdf.setLineWidth(4.0)
      // pdf.setDrawColor(this.info_invitation.areaColor)
      // pdf.setFillColor('#FFFFFF')
      // pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
      // console.log(myBase64); // myBase64 is the base64 string
      // pdf.addImage(myBase64, 'WEBP', 215, 260, 180, 180);
      toDataUrl(this.bandAccessNoCode === true ? this.dataAccessNoCode.company_logo : this.info_invitation.logoEmpresa, (logo_guest) => {
        pdf.addImage(logo_guest, 'WEBP', 0.25, 0.25, 0.9, 0.7);
        pdf.save('gafete.pdf')
        this.loading_gafete = false
        this.band_current_time = false
      });
    },
    async getFileFromUrl(url, filename, mimeType) {
      // Fetch the data from the URL
      const response = await fetch(url);
      
      // Get the response data as a Blob
      const blob = await response.blob();
      
      // Determine the MIME type from the response header, or use a default
      const type = mimeType || blob.type || 'application/octet-stream';
      
      // Determine the filename if not provided
      const name = filename || url.substring(url.lastIndexOf('/') + 1);

      // Create a new File object from the Blob
      return new File([blob], name, { type });
    }
  }
};
</script>

<style>
html, body, #app {
  height: 100%;
}
</style>